export default "__VITE_PUBLIC_ASSET__3863063d__"